/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Fulfillment_Waiting_On_ShipmentInputs */

const en_fulfillment_waiting_on_shipment = /** @type {(inputs: Fulfillment_Waiting_On_ShipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on the warehouse · shipment · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on the warehouse · shipment · since {since}" |
*
* @param {Fulfillment_Waiting_On_ShipmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_waiting_on_shipment = /** @type {((inputs: Fulfillment_Waiting_On_ShipmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Waiting_On_ShipmentInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_waiting_on_shipment(inputs)
});